export const Colors = {
  SUCCESS: '#4CAF50',
  DANGER: '#F44336',
  WARNING: '#FF9800',
  LIGHT_BLUE: '#229DEC',
  PRIMARY_BLUE: '#263465',
  PRIMARY_LIGHTER_BLUE: '#00AAFF',
  PRIMARY_LIGHT_BLUE: '#2580AC',
  PRIMARY_LIGHT_DARK: '#1A2446',
  PRIMARY_DARKER_BLUE: '#061445',
  SECONDARY_LIGHT_BLUE: '#1077B9',
  SECONDARY_LIGHTER_BLUE: '#64B6F7',
  SECONDARY_BLUE: '#2580ac',
  SECONDARY_LIGHT_DARK: '#3F92C7',
  SECONDARY_DARKER_BLUE: '#292F36',
  TERTIARY_DARK_BLUE: '#0B5583',
  TERTIARY_BLUE: '#1EBFFF',
  BOX_SHADOW: 'rgba(0,0,0,.3);',
  PRIMARY_GREEN: '#00AA00',
  PRIMARY_YELLOW: '#FFAA00',
  PRIMARY_RED: '#EE0020',
  LIGHT_OPACITY_GREY: 'rgba(0, 0, 0, 0.54)',
  LIGHTER_GREY: '#9E9E9E',
  LIGHT_GREY: '#E0E0E0',
  GREY: '#BBBBBB',
  GREY_100: '#F5F5F5',
  GREY_150: "#BDBDBD",
  GREY_800: '#424242',
  SECONDARY_GREY: '#CCCCCC',
  DARK_GREY: '#757575',
  GREY_RGBA: 'rgba(0, 0, 0, 0.54)',
  TERTIARY_GREY: '#EEEEEE',
  SECONDARY_DARK_GREY: '#999999',
};
